import React from "react";
import WorkSchedule from "../../components/features/attendance/WorkSchedule";

const WorkSchedulePage = () => {
  return <WorkSchedule />;
};

export default WorkSchedulePage;
